import React, { Fragment } from 'react';
import Button from 'reactstrap/lib/Button';
import { CmsEntities } from 'client/data/models/cms';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';
import { EdmundsUniverse } from 'site-modules/shared/components/edmunds-universe/edmunds-universe';
import { CardTabs } from 'site-modules/editorial/components/about-article/card-tabs/card-tabs';
import { ArticleVideo } from 'site-modules/editorial/components/article-video/article-video';

import './research-entry.scss';

export const ENTRY_RENDER_TYPE = {
  HTML: 'html',
  CARD_TABS: 'card-tabs',
  VIDEO: 'video',
};

export const ENTRY_ID = {
  EDMUNDS_UNIVERSE: 'edmunds-universe',
};

function printPageDialog() {
  if (window) {
    window.print();
  }
}

export function ResearchEntry({ entry }) {
  const entryRenderType = entry.metadata('renderType').value();
  let renderEntry = null;

  if (entryRenderType) {
    switch (entryRenderType) {
      case ENTRY_RENDER_TYPE.HTML: {
        const htmlContent = entry.metadata('htmlContent').value();
        const htmlTitle = entry.metadata('htmlTitle').value();
        const showPrintButton = entry.metadata('showPrintButton').value();
        const printButtonText = entry.metadata('printButtonText').value() || 'Print';
        renderEntry = !!htmlContent && (
          <Fragment>
            {!!htmlTitle && (
              <ContentFragment componentToUse="h2" classes="heading-3 mb-1">
                {htmlTitle}
              </ContentFragment>
            )}
            {!!showPrintButton && (
              <Button
                color="link"
                className="text-capitalize size-16 fw-normal mt-0 p-0 mb-1_5 print-button"
                onClick={printPageDialog}
              >
                <i className="icon-printer3 pe-0_5" aria-hidden />
                {printButtonText}
              </Button>
            )}
            <ContentFragment classes="text-gray-darker size-16">{htmlContent}</ContentFragment>
          </Fragment>
        );
        break;
      }
      case ENTRY_RENDER_TYPE.CARD_TABS: {
        renderEntry = <CardTabs entry={entry} />;
        break;
      }
      case ENTRY_RENDER_TYPE.VIDEO: {
        const { title: videoHeading } = entry;

        renderEntry = (
          <Fragment>
            <h2 className="heading-3 mb-1_5">{videoHeading}</h2>
            <ArticleVideo entry={entry} />
          </Fragment>
        );
        break;
      }
      default: {
        break;
      }
    }
  } else {
    switch (entry.id) {
      case ENTRY_ID.EDMUNDS_UNIVERSE: {
        renderEntry = <EdmundsUniverse />;
        break;
      }
      default: {
        break;
      }
    }
  }

  return !!renderEntry && <div className="about-research-entry">{renderEntry}</div>;
}

ResearchEntry.propTypes = {
  entry: CmsEntities.Content.isRequired,
};
